import { API_HOST } from "./config"
export default {
  AVERAGE_RATINGS: `${API_HOST}front/rating/get_average_rating`,
  ADD_RATING: `${API_HOST}front/rating/add_rating`,
  ADD_REVIEW: `${API_HOST}front/rating/add_review`,
  GET_REVIEWS: `${API_HOST}front/rating/get_reviews`
}
